import { toNumber } from './toNumber';

export function toNumberOrNull(value: string | number | null): number | null {
  if (value === null) {
    return null;
  }

  return toNumber(value);
}
